import $ from 'jquery';

export default function toggleSaveNavMenu() {
  $('#nav-default').toggle();
}
